<template>
  <amplify-authenticator username-alias="email">
    <amplify-sign-up
      slot="sign-up"
      username-alias="email"
      :form-fields.prop="formFields"
    ></amplify-sign-up>
    <amplify-sign-in slot="sign-in" username-alias="email"></amplify-sign-in>
    <amplify-sign-out></amplify-sign-out>
  </amplify-authenticator>
</template>

<script>
export default {
  name: "AuthWithSlots",
  data() {
    return {
      formFields: [
        {
          type: "email",
          label: "Email Address *",
          placeholder: "Enter your email address",
          required: true,
        },
        {
          type: "password",
          label: "Password *",
          placeholder: "Enter your password",
          required: true,
        },
      ],
    };
  },
};
</script>
